module.exports = __webpack_public_path__ + "media/assets/images/solutions/timely_interventions/hero_image-6e75d47ee6a34bf442f32b8efdeccc72.png";